module.exports = __webpack_public_path__ + "static/media/play.c47cb0da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Discography/icons/play.svg
// module id = 74
// module chunks = 0